module.exports = __webpack_public_path__ + "static/mid_02-5863c4f29017b8a72f03b67a4c466414.png";